import React from 'react';
import { Typography } from '@mui/material';

interface LabelProps {
	/** The label's text */
	children: React.ReactNode;
	/** The label's text color */
	color?: string;
	/** The label's background color */
	backgroundColor?: string;
}

/**
 * This component shows text
 */
function Label({ children, color, backgroundColor }: LabelProps) {
	return (
		<Typography
			className="inline-flex items-center"
			sx={{ color, backgroundColor, pt: '4px', pb: '4px', pl: '8px', pr: '8px' }}
		>
			{children}
		</Typography>
	);
}

export default React.memo(Label);
